import { render, staticRenderFns } from "./SkyStepViewCaseDesign.vue?vue&type=template&id=060cfff0"
import script from "./SkyStepViewCaseDesign.vue?vue&type=script&lang=js"
export * from "./SkyStepViewCaseDesign.vue?vue&type=script&lang=js"
import style0 from "./SkyStepViewCaseDesign.vue?vue&type=style&index=0&id=060cfff0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports